import React, { useState,useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CustManCards from './CustManCards';
import { Icon } from '@iconify/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { Switch, FormControlLabel } from '@mui/material';//
import warningIcon from '../common/asset1/warning-symbol.svg';
import successtick from '../common/asset1/tick-mark.png';
import './NewUserReg.css';
import { CheckCircle as CheckCircleIcon, Cancel as CancelIcon, Error as ErrorIcon } from '@mui/icons-material';
import { useSelector} from 'react-redux';

const NewUserReg = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isRegistered, setIsRegistered] = useState(false);
  const [registeredName, setRegisteredName] = useState('');
  const [loginType, setLoginType] = useState(1); 
const [customerId, setCustomerId] = useState('');
const userToken = useSelector((state) => state.auth.token);
const [passwordValidations, setPasswordValidations] = useState({
  length: false,
  uppercase: false,
  number: false,
  noSpaces: false,
});
const [isPasswordFocused, setIsPasswordFocused] = useState(false);
useEffect(() => {
  setPasswordValidations({
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    number: /\d/.test(password),
    noSpaces: !/\s/.test(password),
  });
}, [password]);
  const onClickGoBack = () => {
    navigate('/admin/home/customer-management');
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handleCreateAccount = async () => {
    setErrors({});
    if (!username) {
      setErrors((prev) => ({ ...prev, username: 'Username is required' }));
      return;
    }
    if (!password) {
      setErrors((prev) => ({ ...prev, password: 'Password is required' }));
      return;
    }
    if (!confirmPassword) {
      setErrors((prev) => ({ ...prev, confirmPassword: 'Confirm Password is required' }));
      return;
    }
    if (password !== confirmPassword) {
      setErrors((prev) => ({ ...prev, confirmPassword: 'Passwords do not match' }));
      return;
    }
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setErrors((prev) => ({ ...prev, email: 'Invalid email format' }));
      return;
    }

    const payload = {
      id: 0,
      username,
      fullName,
      mobileNumber,
      email,
      password,
      confirmPassword,
      loginType,
    };

    try {
      const response = await fetch('https://localhost:7040/api/account/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
          authtorizon: `Bearer ${userToken}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        console.log('Form submitted successfully');
        setIsRegistered(true);
        setRegisteredName(username); 
      } else {
        setErrors({ general: result.message || `Registration failed with status: ${response.status}` });
      }
    } catch (error) {
      setErrors({ general: 'An error occurred. Please try again later.' });
    }
  };
  const passwordsMatch = password === confirmPassword;
  const validateUsername = (value) => {
    const userNameRegex = /^[a-zA-Z0-9._-]+$/;
    const numericOnlyCheck = /^\d+$/;
    return userNameRegex.test(value) && !numericOnlyCheck.test(value);
  };
  const validateMobileNumber = (value) => /^\d{0,10}$/.test(value);
  const validateFullName = (value) => /^[a-zA-Z\s]*$/.test(value);


  
  return (
    <div className="whole-mysave-cont">
      <CustManCards />
      <div className="create-user-out">
        <button className="get-back-out" onClick={onClickGoBack}>
          <Icon icon="iconamoon:arrow-left-2-bold" className="go-back-symbol" />
          Go Back
        </button>
        <h3>{loginType === 1 ? 'Create a New User Account' : 'Register an Admin Account'}</h3>
        <FormControlLabel
          control={
            <Switch
              checked={loginType === 0}
              onChange={() => setLoginType((prev) => (prev === 1 ? 0 : 1))}
              color="primary"
            />
          }
          label= {
            <span style={{ fontWeight: 'bold', color: loginType === 1 ? 'blue' : 'green' }}>
          {loginType === 1 ? 'Switch to Admin Account' : 'Switch to User Account'}
          </span>
  }
        />
        {!isRegistered ? (
          <>
            <div className="new-user-cont">
              <div className="form-group">
                <label>
                  User Name<span className="required">*</span>
                </label>
                <input
              type="text"
             value={username}
                  onChange={(e) => {
                  const value = e.target.value;
                  if (validateUsername(value)) setUsername(value);
                    }}
                   required
                 />
                {errors.username && (
                  <div className="error-reg-icon-out">
                    <img
                      src={warningIcon}
                      alt="Warning-Icon"
                      className="warning-icon"
                    />
                    <span className="error-register-now">{errors.username}</span>
                  </div>
                )}
              </div>
              <div className="form-group">
                <label>Full Name</label>
                <input
              type="text"
             value={fullName}
                onChange={(e) => {
               const value = e.target.value;
                 if (validateFullName(value)) setFullName(value);
                }}
                required
                   />
                {errors.fullName && (
                  <div className="error-reg-icon-out">
                    <img
                      src={warningIcon}
                      alt="Warning-Icon"
                      className="warning-icon"
                    />
                    <span className="error-register-now">{errors.fullName}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="new-user-cont">
              <div className="form-group">
                <label>
                  Mobile Number<span className="required">*</span>
                </label>
                <div className="input-container">
                  <span className="country-code">+91 </span>
                  <input
              type="text"
                value={mobileNumber}
               onChange={(e) => {
               const value = e.target.value;
                 if (validateMobileNumber(value)) setMobileNumber(value);
               }}
                required
                />

                </div>
                {errors.mobileNumber && (
                  <div className="error-reg-icon-out">
                    <img
                      src={warningIcon}
                      alt="Warning-Icon"
                      className="warning-icon"
                    />
                    <span className="error-register-now">
                      {errors.mobileNumber}
                    </span>
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>Email (optional)</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {errors.email && (
                  <div className="error-reg-icon-out">
                    <img
                      src={warningIcon}
                      alt="Warning-Icon"
                      className="warning-icon"
                    />
                    <span className="error-register-now">{errors.email}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="new-user-cont">
  <div className="form-group">
    <label>Password</label>
    <div className="password-container">
      <input
        type={showPassword ? "text" : "password"}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        onFocus={() => setIsPasswordFocused(true)}
        onBlur={() => setIsPasswordFocused(false)}
        required
      />
      <FontAwesomeIcon
        icon={showPassword ? faEyeSlash : faEye}
        onClick={toggleShowPassword}
        className="password-icon"
      />
    </div>
    {isPasswordFocused && (
      <div className="password-validation">
        <div style={{ color: passwordValidations.length ? '#45A145' : '#E51A1A' }}>
          {passwordValidations.length ? (
            <CheckCircleIcon style={{ color: '#45A145', marginRight: '8px' }} />
          ) : (
            <ErrorIcon style={{ color: '#E51A1A', marginRight: '8px' }} />
          )}
          Password must be at least 8 characters
        </div>
        <div style={{ color: passwordValidations.uppercase ? '#45A145' : '#E51A1A' }}>
          {passwordValidations.uppercase ? (
            <CheckCircleIcon style={{ color: '#45A145', marginRight: '8px' }} />
          ) : (
            <ErrorIcon style={{ color: '#E51A1A', marginRight: '8px' }} />
          )}
          Must contain at least one uppercase letter
        </div>
        <div style={{ color: passwordValidations.number ? '#45A145' : '#E51A1A' }}>
          {passwordValidations.number ? (
            <CheckCircleIcon style={{ color: '#45A145', marginRight: '8px' }} />
          ) : (
            <ErrorIcon style={{ color: '#E51A1A', marginRight: '8px' }} />
          )}
          Must contain at least one number
        </div>
        <div style={{ color: passwordValidations.noSpaces ? '#45A145' : '#E51A1A' }}>
          {passwordValidations.noSpaces ? (
            <CheckCircleIcon style={{ color: '#45A145', marginRight: '8px' }} />
          ) : (
            <ErrorIcon style={{ color: '#E51A1A', marginRight: '8px' }} />
          )}
          No spaces allowed
        </div>
      </div>
    )}
    {errors.password && (
      <div className="error-reg-icon-out">
        <img src={warningIcon} alt="Warning-Icon" className="warning-icon" />
        <span className="error-register-now">{errors.password}</span>
      </div>
    )}
  </div>

  <div className="form-group">
    <label>Confirm Password</label>
    <div className="password-container">
      <input
        type={showConfirmPassword ? "text" : "password"}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        required
      />
      <FontAwesomeIcon
        icon={showConfirmPassword ? faEyeSlash : faEye}
        onClick={toggleShowConfirmPassword}
        className="password-icon"
      />
    </div>
    {confirmPassword.length > 0 && (
      <div style={{ color: passwordsMatch ? '#45A145' : '#E51A1A' }}>
        {passwordsMatch ? (
          <CheckCircleIcon style={{ color: '#45A145', marginRight: '8px' }} />
        ) : (
          <ErrorIcon style={{ color: '#E51A1A', marginRight: '8px' }} />
        )}
        {passwordsMatch ? 'Passwords match' : 'Passwords do not match'}
      </div>
    )}
    {errors.confirmPassword && (
      <div className="error-reg-icon-out">
        <img src={warningIcon} alt="Warning-Icon" className="warning-icon" />
        <span className="error-register-now">{errors.confirmPassword}</span>
      </div>
    )}
  </div>
</div>

            {errors.general && (
              <div className="error-reg-icon-out">
                <img
                  src={warningIcon}
                  alt="Warning-Icon"
                  className="warning-icon"
                />
                <span className="error-register-now">{errors.general}</span>
              </div>
            )}

            <button className="btn-create-account" onClick={handleCreateAccount}>
              Create Account
            </button>
          </>
        ) : (
          <div className="success-message-teeny-cont">
            <div className="success-icon-wrapper">
              <img
                src={successtick}
                alt="success-mark"
                className="success-tick-mark"
              />
            </div>
            <p>Account Created Successfully</p>
            <div className="created-name-id-out">
            <div className='created-name-id'>
              <label>Name: </label>
              <span>{registeredName}</span>
            </div>
            <div>
              <label>Customer ID: </label>
              <span>{customerId}</span>
            </div>
          </div>
            <div className="created-btn-grp">
              <button className = "created-reg-view">
              <Link to="/signin" className="created-register-name-btn-view">
               View Profile
              </Link>
              </button>
              <button className = "created-join-newscheme">
              <Link to="/signin" className="created-register-name-btn-join">
                Join a New Scheme
              </Link>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewUserReg;